var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "template_a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 0v821H0V0h1440Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "template_b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h9Zm0 2H4a2 2 0 0 0-1.995 1.85L2 9v9a2 2 0 0 0 1.85 1.995L4 20h9a2 2 0 0 0 1.995-1.85L15 18V9a2 2 0 0 0-1.85-1.995L13 7Zm5-7a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4v-2a2 2 0 0 0 1.995-1.85L20 13V4a2 2 0 0 0-1.85-1.995L18 2H9a2 2 0 0 0-1.995 1.85L7 4H5a4 4 0 0 1 4-4h9Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#template_a)",
    transform: "translate(-851 -765)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#template_b)",
    transform: "translate(851 765)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFB170",
    d: "M0 0h22v22H0V0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/TemplateIcon.0f784aec5e2499e5d510398f76bf9d9c.svg";
export { ForwardRef as ReactComponent };